import { useParams } from 'react-router-dom'
import { useGetTasksQuery } from './tasksApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { Outlet } from 'react-router-dom'
import TimeLeft from '../../partial/TimeLeft'
import ReactQuill from 'react-quill'
import getFilePath from "../../utils/getFilePath"
const ShowTask = () => {
    useTitle('geshtop-Exercise: Show Task')

    const { taskId } = useParams()

    const { task } = useGetTasksQuery("tasksList", {
        selectFromResult: ({ data }) => ({
            task: data?.entities[taskId]
        }),
    })

    if (!task) return <PulseLoader color={"#FFF"} />

    const content =<>  <div >
                <h1>{task.title}</h1>
                <h3>{task.groupname}</h3>
                    <p className="public__addr">
                    <ReactQuill
                     theme='bubble'
                    readOnly
                    value={ task.body}
                    
                    ></ReactQuill>
                     {/* {task.body} */}
                    </p>
                    {task.img && <img className='user-img' src={getFilePath(task.img)} />}
                <br />
                <p>הזמן שנותר	:<TimeLeft endtime={task.toDate} /></p>
               
            </div>
             <Outlet />
             </>
            

    return content
}
export default ShowTask